<div [formGroup]="uploadImageForm">
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <p>Please click 'Choose File' to select an image to upload.
      It may take a few seconds for the 'file upload' window to appear. </p>

      @if (fileUpload.status === 'done') {
        <div class="usa-alert usa-alert--success usa-alert--no-icon">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{fileUpload.message}}
            </p>
          </div>
        </div>
      }
      @if (fileUpload.status === 'error') {
        <div class="usa-alert usa-alert--error usa-alert--no-icon">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{fileUpload.message}}
            </p>
          </div>
        </div>
      }

      <input type="file" class="usa-input maxw-full" formControlName="filePicker" name="filePicker"
        id="filePicker" (change)="fInput($event);">
      <button type="button" class="usa-button"
        [disabled]="uploadImageForm.invalid && fileUpload.status === 'ok'" (click)="upload();">Click to upload
      image</button>
      @if (fileUpload.status === 'uploading') {
        <progressbar class="progressBarStyle" max="100"
          [value]="fileUpload.message" type="success" [striped]="true" [animate]="true">
          <i>{{fileUpload.message}}%</i>
        </progressbar>
      }

    </div>
  </div>
</div>